'use client';

import Session from '@/components/Session';
import logo from '@/assets/images/logo.png';

export default function Header() {
    return (
        <>
            <Session className='header'>
                <div className='logos'>
                    <img
                        className='logo'
                        src={logo.src}
                        alt='Logo'
                    />
                </div>
            </Session>
        </>
    );
}
